import styled from "styled-components"

import { maxWidth } from "utils"

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  background: #fff;
  padding: 2rem;
  border: 1px solid #e5e5e5;
  border-radius: 0.75rem;

  ${maxWidth.mobile`
    width: 30rem;
  `}
`

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  bottom: 0.8rem;
  left: 0.4rem;
  border-radius: 0.4rem;
  max-width: 85%;
  z-index: 1;
`

export const Error = styled.div`
  width: 100%;
  margin-top: 1rem;
  margin-left: 0.5rem;
  line-height: 1.16rem;
  color: #b6471f;
  font-size: 1.2rem;
  text-align: start;
`
